document.addEventListener('DOMContentLoaded', function() {
  const textItems = document.querySelectorAll('.rotating-text__item');
  let currentIndex = 0;
  const totalItems = textItems.length;
  const duration = 2000; // Duration each text stays visible (in ms)

  // Function to show and hide text items
  function rotateText() {
    // Hide the current text item
    textItems[currentIndex].style.display = 'none'; // Hide the current item

    // Move to the next index
    currentIndex = (currentIndex + 1) % totalItems; // Loop back to the first item

    // Show the new text item
    textItems[currentIndex].style.display = 'block'; // Show the new item
  }

  // Initialize the first item
  textItems[currentIndex].style.display = 'block'; // Show the first item

  // Set an interval to switch text every 2 seconds
  setInterval(rotateText, duration);
});
